import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" clip-path=\"url(#a)\"><path d=\"M3.333 4.999A1.667 1.667 0 0 1 5 3.332h10a1.667 1.667 0 0 1 1.667 1.667v10A1.667 1.667 0 0 1 15 16.665H5A1.667 1.667 0 0 1 3.333 15z\"></path><path d=\"M10 3.332v5.833L11.667 7.5l1.666 1.666V3.332\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h20v20H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }